import React, { useEffect, useState, useRef } from "react";
import './style.css';
import {
    Button,
    List,
    Row,
    Col,
    Modal,
    Spin,
    Avatar,
    Image,
} from "antd";
import {
    DeleteOutlined,
    SyncOutlined
} from "@ant-design/icons";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import SignatureCanvas from 'react-signature-canvas';
import { getSignatureList, addSignature, delSignature, clearState, clearStateAddSign, ViewSignatureListSelector } from './ModifySignatureSlice';
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;


const data = [
    {
        id: 2,
        image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWQAAACQCAYAAAA/bxGbAAAAAXN'
    }
];

export default function ModifySignature() {

    const dispatch = useDispatch();
    const [isLoading, setLoading] = React.useState(false);
    const [isToast, setToast] = React.useState(false);
    const [SignatureData, setSignatureData] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isAddSignModalVisible, setIsAddSignModalVisible] = useState(false);
    const canvasRef = useRef(null);


    const { isFetching, SignData, isSignSuccess, isSignAdded, signCount, isError, imagePath, errorMessage } = useSelector(
        ViewSignatureListSelector
    );

    useEffect(() => {
        setToast(false);
        dispatch(clearState());
        dispatch(clearStateAddSign());
        dispatch(getSignatureList());
    }, []);

    useEffect(() => {

        if (isError) {
            setToast(true);
            toast.error(errorMessage);
            dispatch(clearState());
            dispatch(clearStateAddSign());
        }
        if (isSignSuccess) {
            setSignatureData(SignData);
        }
        if (isSignAdded) {
            dispatch(clearStateAddSign());
            canvasRef.current?.clear();
            setIsAddSignModalVisible(false);
            dispatch(getSignatureList());
        }

    }, [isError, isFetching, SignData, isSignSuccess, isSignAdded, signCount, errorMessage, imagePath, setLoading, setToast]);



    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleDelSign = (e, value) => {
        e.preventDefault();
        // console.log("id=> ", value._id);
        const getAnswer = async () => {
            let a = await dispatch(delSignature(value._id));
            dispatch(getSignatureList());
        };
        getAnswer();

    }

    // Add sign modal METHODS....

    const AddSignModal = () => {
        setIsAddSignModalVisible(true);
    };

    const clearSignature = () => {
        canvasRef.current?.clear();
    };

    const handleOk = () => {
        if (!canvasRef.current?.isEmpty()) {
            const simg = canvasRef.current?.getTrimmedCanvas().toDataURL('image/png');
            // console.log(simg)
            let data = {
                "signature": simg
            }
            dispatch(addSignature(data));
        }
        canvasRef.current?.clear();
        setIsAddSignModalVisible(false);
    };

    const AddSignModalCancel = () => {
        canvasRef.current?.clear();
        setIsAddSignModalVisible(false);

    };

    return (
        <>
            {/* <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} /> */}
            {isToast &&
                <Toaster
                    toastOptions={{
                        className: '',
                        style: {
                            border: '1px solid #713200',
                            padding: '16px',
                            color: '#713200',
                            marginTop: 50
                        },
                    }}
                >
                    {(t) => (
                        <ToastBar toast={t}>
                            {({ icon, message }) => (
                                <>
                                    {icon}
                                    {message}
                                    {t.type !== 'loading' && (
                                        <button onClick={() => toast.dismiss(t.id)}>X</button>
                                    )}
                                </>
                            )}
                        </ToastBar>
                    )}
                </Toaster>
            }

            <Button type="link" style={{ color: "#000", fontWeight: 500 }} onClick={showModal} >Modify Signature</Button>
            <Modal width={500} className="modify-signature-modal" centered closable={false}
                cancelButtonProps={{ style: { display: 'none' } }}
                title="" visible={isModalVisible} onOk={handleCancel}>
                <div className="title-sec">
                    <Row>
                        <Col span={12}>
                            <h2 style={{ margin: '0px' }}>Modify Signature</h2>
                        </Col>
                        <Col span={12}>
                            {signCount && signCount > 0 ? "" : <Button size={'small'} type="link" style={{ padding: "6px 8px 8px 118px", fontSize: 18, fontWeight: 'normal' }} onClick={AddSignModal}>
                                <span>+Add Sign</span>
                            </Button>}
                        </Col>
                    </Row>
                </div>
                <Row className="form-row" style={{ marginTop: '0px !important' }}>
                    <Col span="24">
                        <Row><Col span={24} style={{ padding: "20px 20px 0px 38px" }}><h3>Saved Signature ({signCount ? signCount : 0})</h3></Col></Row>
                        <List
                            className="modify-signature-list"
                            itemLayout="horizontal"
                            dataSource={SignatureData}
                            renderItem={item => (
                                <List.Item actions={[<DeleteOutlined onClick={(e) => handleDelSign(e, item)} className="mody-del-btn" />]}>

                                    <List.Item.Meta
                                        // avatar={<Image preview={false} src={imagePath + item.base64} />}
                                        avatar={<Image preview={false} src={item.base64} />}
                                    />
                                </List.Item>
                            )}
                        />

                    </Col>
                </Row>
            </Modal>

            {/* Add sign modal starts here .... */}

            <Modal title={
                <Row>
                    <Col span={16}>Add Signature</Col>
                    <Col span={8}>
                        <Button onClick={() => clearSignature()} size={'small'} style={{ float: 'right', marginRight: 20 }} type={'primary'} ghost>Clear</Button>
                    </Col>
                </Row>} visible={isAddSignModalVisible} onOk={handleOk} onCancel={AddSignModalCancel}>
                <SignatureCanvas penColor='black'
                    ref={canvasRef}
                    canvasProps={{ width: 470, height: 200, className: 'sigCanvasinitial' }} />
            </Modal>

        </>
    );
}
